import React, { Component } from 'react'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import { connect } from 'react-redux'
import { nest, lifecycle, mapProps, withState, withHandlers, compose } from 'recompose'
import injectSagas from 'helpers/injectSagas'
import CSSModules from 'helpers/CSSModulesUtil'

import ProgressBarHoc from 'containers/Async/AsyncProgressBar'
import Card from './Card'
import List from './List'
import Actions from './Actions'
import Divider from 'components/fulcrum/divider/Divider'
import Collapse from 'components/fulcrum/collapse/Collapse'
import UserInput from './UserInput'
import CardHeader from 'components/custom/Card/CardHeader'
import Section from 'components/custom/Section/Section'

import {
  MODULE_NAME,
  FETCH_SUBSTITUTES,
} from './constants'

import {
  fetchEmployeeListWithImages as fetchEmployeeList,
} from 'containers/User/actions'

import {
  employeeListWithImageValues as employeeListSelector,
  isLoadingEmployeeList,
} from 'containers/User/selectors'

import {
  saveSubstitutes,
  fetchSubstitutes,
  postSubstitutes,
  updateSubstitutes,
  clearNewSubstitute,
  addNewSubstitute,
  addSubstitute,
  deleteSubstitutes,
} from './actions'

import {
  substitutesWithImagesValues,
  newSubstituteSelector,
} from './selectors'

import substitutesSagas from './sagas'

const ProgressBar = ProgressBarHoc([
  FETCH_SUBSTITUTES
])

const SectionCard = (props) => {
  const {
    substitutes,
    newSubstitute,
    addSubstitute,
    employeeList,
    fetchEmployeeList,
    isLoading,
    onChange,
    onInputChange,
    collapse,
    onRemove,
    ...rest,
  } = props

  return (
    <Card>
      <CardHeader title='Substitutes'>
        <Actions
          collapse={collapse}
          {...props}
        />
      </CardHeader>
      <Collapse collapse={collapse}>
        <Divider/>
        <ProgressBar/>
        <List
          substitutes={substitutes}
          edit={props.edit}
          onChange={onChange}
          onRemove={onRemove}
        />
        <UserInput
          options={employeeList}
          onInputChange={fetchEmployeeList}
          onChange={onInputChange}
          isLoading={isLoading}
          edit={props.edit}
          value={newSubstitute}
          addSubstitute={addSubstitute}
        />
      </Collapse>
    </Card>
  )
}
const SubstituteSection = nest(Section, SectionCard)

const withModify = compose(
  withState('edit', 'toggleEdit', false),
  withHandlers({
    toggleEdit: ({ toggleEdit }) => () => toggleEdit(e => !e)
  })
)

const withCollapse = compose(
  withState('collapse', 'toggleCollapse', false),
  withHandlers({
    toggleCollapse: ({ toggleCollapse }) => () => toggleCollapse(t => !t)
  })
)

const withLifeCycle = lifecycle({
  componentDidMount() {
    const { fetchSubstitutes } = this.props
    fetchSubstitutes()
  }
})

const mapStateToProps = (state) => {
  return {
    employeeList: employeeListSelector(state),
    isLoading: isLoadingEmployeeList(state),
    substitutes: substitutesWithImagesValues(state),
    newSubstitute: newSubstituteSelector(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchEmployeeList: (query) => dispatch(fetchEmployeeList(query)),
    fetchSubstitutes: () => dispatch(fetchSubstitutes()),
    onChange: (substitute) => dispatch(updateSubstitutes(substitute)),
    onInputChange: (username) => dispatch(addNewSubstitute(username)),
    addSubstitute: (substitute) => dispatch(addSubstitute(substitute)),
    clearNewSubstitute: () => dispatch(clearNewSubstitute()),
    onSave: () => dispatch(saveSubstitutes()),
    onRemove: (substitute) => dispatch(deleteSubstitutes(substitute))
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withSagas = injectSagas({ substitutesSagas })
export default compose(
  withSagas,
  withConnect,
  withCollapse,
  withModify,
  withLifeCycle,
)(SubstituteSection)
